import { Link } from "gatsby"
import resolveLink from "../../utils/resolveLink"
import React, { useEffect, useState } from "react"
import {
  connectHits,
  Index
} from "react-instantsearch-dom"
import Heading from "src/components/Heading"
import ContentLabel from 'src/components/ContentLabel'
import InsightsBadge from "src/images/insights-logo.svg"
import { SearchIcon } from '@heroicons/react/solid'
import ShortenText from 'src/utils/ShortenText'

const PageHit = ({ hit }) => {
  return (
    <Link className="group relative" to={resolveLink(`/${hit.full_slug}`)}>
        <div className="absolute left-0 top-0 z-10">
            <ContentLabel type={hit.component} />
        </div>
        <div className="relative w-full min-h-80 bg-gray-200 overflow-hidden group-hover:opacity-75 lg:h-80">
            <img className="w-full h-full object-center object-cover lg:w-full lg:h-full" src={`${hit.thumbnail_image?.filename}/m/1000x1000`} alt={hit.thumbnail_image.alt}/>
            {hit.component === 'magazine' && <InsightsBadge className="h-12 absolute bottom-2.5 left-2.5"/>}
        </div>
        <div className="mt-4 flex justify-between">
            <h3 className={`${hit.component === 'magazine' ? 'text-lg text-darkgrey font-insights-display'  : 'text-3xl text-darkgrey font-display'}`}>
                {hit.name}
            </h3>
        </div>
        <div className={`mt-2 prose text-xs text-darkgrey ${hit.component === 'magazine' ? 'font-insights-body' : 'font-body'}`}>
          {ShortenText(hit.description)}
        </div>
    </Link>    
  )
}

const Hits = ({ hits }) => {
  const [noResults, setNoResults] = useState()
  // Check if there are any search results
  useEffect(() =>{
    if( hits.length < 1 ) {
      setNoResults(true)
    } else {
      setNoResults(false)
    }
  }, [hits])

  return (
    <>
    <div className="max-w-7xl mx-auto mt-6 grid grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-2 lg:grid-cols-3 xl:gap-x-8">
      {hits.map(hit => (
        <PageHit hit={hit} key={hit?._uid+hit?.full_slug}/>
      ))}
    </div>
    {noResults &&
      <div className="max-w-2xl mx-auto flex flex-col justify-center items-center text-center gap-4 py-24">
        <SearchIcon className="h-8 w-8 text-red" aria-hidden="true" />
        <Heading size="h4" className="text-darkgrey">we didn’t find any match for your search.</Heading>
      </div>
    }
    </>
  )
}

const CustomHits = connectHits(Hits);

const HitsInIndex = ({ index }) => (
  <Index indexName={index.name}>
    <CustomHits />
  </Index>
)

const SearchResult = ({ indices, show }) => (
  <div>
    <Heading size="h3" className="text-darkgrey">Insights</Heading>
    {indices.map(index => (
      <HitsInIndex index={index} key={index.name} />
    ))}
  </div>
)

export default SearchResult